exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/player-display/player-display.component.scss
// module id = ../../../../../src/app/component-module/player-display/player-display.component.scss
// module chunks = main